import { Label } from "expano-components";
import { MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const ChannelsList = ({history}) => (
  <Main
    page={{
      name: "Kanały",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Kanały",
        },
      ],
    }}
  >
    <MainList
      query_key="channels"
      api_path="/channels"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/channels/${item.id}`)}
      renderItem={({ id, identifier, shop, platform }) => (
        <>
          <td>{id}</td>
          <td>{identifier}</td>
          <td>
            <Label
              type="double"
              left={{
                text: shop?.label_text,
                color: `#${shop?.label_color}`,
              }}
              right={{
                text: platform?.label_text,
                color: `#${platform?.label_color}`,
              }}
            />
          </td>
          <td>
            <Label
              type="fill"
              text={shop?.label_text}
              color={shop?.label_color}
            />
            {shop?.name}
          </td>
          <td>
            <Label
              type="bordered"
              text={platform?.label_text}
              color={platform?.label_color}
            />
            {platform?.name}
          </td>
        </>
      )}
    />
  </Main>
);

export default ChannelsList;
